<div class="container">
  <span class="title">{{ 'reward-unlocked-title' | translate}}</span>
  <div class="imageRewardContainer">
    @if (imageToWinUrl!=='') {
      <img [attr.src]="imageToWinUrl" alt=""/>
    }
  </div>
  <span class="title">{{itemToWinLabel}}</span>
  @if (ready) {
    <button (click)="next()">{{'generic.next'|translate}}</button>
  }
</div>
